/* Código auto generado */

import type { Lang, LangLabel } from '@appTypes';

export const LANG_LABELS: Record<Lang, Record<LangLabel, string>> = {
  'es': {
    'success': 'Correcto',
    'info': 'Información',
    'warning': 'Advertencia',
    'error': 'Error',
    'error401': 'Error 401 - Sin autorización',
    'error404': 'Error 404 - Página no encontrada',
    'year': 'Año',
    'years': 'Años',
    'month': 'Mes',
    'months': 'Meses',
    'january': 'Enero',
    'february': 'Febrero',
    'march': 'Marzo',
    'april': 'Abril',
    'may': 'Mayo',
    'june': 'Junio',
    'july': 'Julio',
    'august': 'Agosto',
    'september': 'Septiembre',
    'october': 'Octubre',
    'november': 'Noviembre',
    'december': 'Diciembre',
    'directory': 'Directorio',
    'registered_icons': 'Íconos registrados',
    'cancel': 'Cancelar',
    'accept': 'Aceptar',
    'add': 'Añadir',
    'export': 'Exportar',
    'search': 'Buscar',
    'filter': 'Filtrar',
    'delete_filters': 'Borrar filtros',
    'clear_filters': 'Limpiar filtros',
    'no_active_filters': 'No tienes filtros activos',
    'select': 'Seleccionar',
    'open': 'Abrir',
    'name': 'Nombre',
    'gender': 'Género',
    'start': 'Inicio',
    'end': 'Fin',
    'start_date': 'Fecha inicio',
    'end_date': 'Fecha fin',
    'start_and_end_date': 'Fecha de inicio y fin',
    'from__date': 'Del',
    'to__date': 'al',
    'select_date': 'Selecciona la fecha',
    'date_type': 'Tipo de fecha',
    'must_select_start_date': 'Debes seleccionar una fecha inicial',
    'must_select_start_date_time': 'Debes seleccionar una fecha y hora inicial',
    'cannot_select_date_earlier_than_initial': 'No puedes seleccionar una fecha anterior a la inicial',
    'cannot_select_datetime_earlier_than_initial': 'No puedes seleccionar una fecha y hora anterior a la inicial',
    'cannot_select_date_after_final': 'No puedes seleccionar una fecha posterior a la final',
    'cannot_select_datetime_after_final': 'No puedes seleccionar una fecha y hora posterior a la final',
    'page': 'Página',
    'pages': 'Páginas',
    'record': 'Registro',
    'records': 'Registros',
    'no_records': 'Sin registros',
    'loading_records': 'Cargando registros',
    'record_of_on': 'Registro %s de un total de %s en %s páginas',
    'records_to_of_on': 'Registros %s a %s de un total de %s en %s páginas',
    'first__m': 'Primero',
    'first__f': 'Primera',
    'last__m': 'Último',
    'last__f': 'Última',
    'previous': 'Anterior',
    'next': 'Siguiente',
    'performed_quick_search_with_fields': 'Has realizado una búsqueda rápida con los siguientes campos',
    'prospect': 'Prospecto',
    'prospect_name': 'Nombre del prospecto',
    'phone': 'Teléfono',
    'enter_name': 'Introduce un nombre',
    'enter_phone': 'Introduce un teléfono',
    'enter_email': 'Introduce un email',
    'enter_date_type': 'Introduce el tipo de fecha',
    'select_date_type': 'Selecciona el tipo de fecha',
    'no_order': 'Sin orden',
    'ascending': 'Ascendente',
    'descending': 'Descendente',
    'tickets': 'Tickets',
    'go_to_category': 'Ir a la categoría',
    'bdc-monthly-indicators': 'Indicadores BDC Mensual',
    'until_current_month': 'Hasta el mes actual',
    'home': 'Home',
    'ia_queries': 'Consultas IA',
    'static_filters': 'Filtros estáticos',
  },
  'en': {
    'success': 'Success',
    'info': 'Information',
    'warning': 'Warning',
    'error': 'Error',
    'error401': 'Error 401 - Unauthorized',
    'error404': 'Error 404 - Page Not Found',
    'year': 'Year',
    'years': 'Years',
    'month': 'Month',
    'months': 'Months',
    'january': 'January',
    'february': 'February',
    'march': 'March',
    'april': 'April',
    'may': 'May',
    'june': 'June',
    'july': 'July',
    'august': 'August',
    'september': 'September',
    'october': 'October',
    'november': 'November',
    'december': 'December',
    'directory': 'Directory',
    'registered_icons': 'Registered icons',
    'cancel': 'Cancel',
    'accept': 'Accept',
    'add': 'Add',
    'export': 'Export',
    'search': 'Search',
    'filter': 'Filter',
    'delete_filters': 'Delete filters',
    'clear_filters': 'Clears filters',
    'no_active_filters': 'You don\'t have active filters',
    'select': 'Select',
    'open': 'Open',
    'name': 'Name',
    'gender': 'Gender',
    'start': 'Start',
    'end': 'End',
    'start_date': 'Start date',
    'end_date': 'End date',
    'start_and_end_date': 'Start and end date',
    'from__date': 'From',
    'to__date': 'to',
    'select_date': 'Select the date',
    'date_type': 'Date type',
    'must_select_start_date': 'You must select a start date',
    'must_select_start_date_time': 'You must select a start date and time',
    'cannot_select_date_earlier_than_initial': 'You cannot select a date earlier than the initial one',
    'cannot_select_datetime_earlier_than_initial': 'You cannot select a date and time earlier than the initial one',
    'cannot_select_date_after_final': 'You cannot select a date after the final one',
    'cannot_select_datetime_after_final': 'You cannot select a date and time after the final one',
    'page': 'Page',
    'pages': 'Pages',
    'record': 'Record',
    'records': 'Records',
    'no_records': 'No records',
    'loading_records': 'Loading records',
    'record_of_on': 'Record %s of a total of %s on %s pages',
    'records_to_of_on': 'Records %s to %s of a total of %s on %s pages',
    'first__m': 'First',
    'first__f': 'First',
    'last__m': 'Last',
    'last__f': 'Last',
    'previous': 'Previous',
    'next': 'Next',
    'performed_quick_search_with_fields': 'You have performed a quick search with the following fields',
    'prospect': 'Prospect',
    'prospect_name': 'Prospect name',
    'phone': 'Phone',
    'enter_name': 'Enter a name',
    'enter_phone': 'Enter a phone',
    'enter_email': 'Enter an email',
    'enter_date_type': 'Enter the date type',
    'select_date_type': 'Select the date type',
    'no_order': 'No order',
    'ascending': 'Ascending',
    'descending': 'Descending',
    'tickets': 'Tickets',
    'go_to_category': 'Go to category',
    'bdc-monthly-indicators': 'BDC monthly indicators',
    'until_current_month': 'Until current month',
    'home': 'Home',
    'ia_queries': 'IA Queries',
    'static_filters': 'Static filters',
  },
};
